function Footer() {
  return (
    <footer className="bg-dark border-top">
      <div className="container">
        <p className="m-0 py-3 text-center text-md-end text-light">
          For project purpose
        </p>
      </div>
    </footer>
  );
}

export default Footer;
